import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "className", "intent", "position", "showClose", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { Enum, PositionType, MaxWidthType, isArray } from '../../../library';
import { Box } from '../../box';
import { Close } from '../../close';
import { Overlay } from '../../overlay';
import { AttachedDialog } from './attached-dialog';
var dialogClasses = {
  MAIN: 'dialog',
  CONTENT: 'dialog__content',
  HEADER: 'dialog__header',
  BODY: 'dialog__body',
  FOOTER: 'dialog__footer'
};
export var DialogSizeType = Enum(_objectSpread({
  AUTO: 'auto',
  FULLWIDTH: 'fullwidth'
}, MaxWidthType));
export var DialogPositionType = Enum(_objectSpread(_objectSpread({}, PositionType), {}, {
  CENTER: 'center'
}));
export var DialogHeader = function DialogHeader(props) {
  return React.createElement(Box.Header, _extends({}, props, {
    className: cn(dialogClasses.HEADER, props.className)
  }));
};
export var DialogBody = function DialogBody(props) {
  return React.createElement(Box.Body, _extends({}, props, {
    className: cn(dialogClasses.BODY, props.className)
  }));
};
export var DialogFooter = function DialogFooter(props) {
  return React.createElement(Box.Footer, _extends({}, props, {
    className: cn(dialogClasses.FOOTER, props.className)
  }));
};
export var Dialog = function Dialog(props) {
  var children = props.children,
    className = props.className,
    intent = props.intent,
    position = props.position,
    showClose = props.showClose,
    size = props.size,
    overlayProps = _objectWithoutProperties(props, _excluded);
  function getAnimationVariants() {
    var _ref = isArray(props.transitionDuration) ? props.transitionDuration : [props.transitionDuration, props.transitionDuration],
      _ref2 = _slicedToArray(_ref, 2),
      enter = _ref2[0],
      exit = _ref2[1];
    var xOffset = 16;
    var yOffset = 16;
    var basePosition = getBasePosition(props.position);
    var startingX = basePosition === 'right' ? xOffset : basePosition === 'left' ? -xOffset : 0;
    var startingY = basePosition === 'top' ? -yOffset : basePosition === 'bottom' || basePosition === 'center' ? yOffset : 0;
    var animationVariants = {
      hidden: {
        opacity: 0,
        translateX: startingX,
        translateY: startingY,
        transition: {
          duration: exit / 1000
        }
      },
      visible: {
        opacity: 1,
        translateX: 0,
        translateY: 0,
        transition: {
          duration: enter / 1000
        }
      }
    };
    return animationVariants;
  }
  var classNames = cn(dialogClasses.MAIN, _defineProperty(_defineProperty({}, "-".concat(position), position), '-scrollable', props.allowOverflow), className);
  var contentClassNames = cn(dialogClasses.CONTENT, _defineProperty({}, "-".concat(size), size));
  return React.createElement(Overlay, _extends({}, overlayProps, {
    isBlocking: props.allowOverflow ? true : overlayProps.isBlocking
  }), React.createElement("div", {
    className: classNames
  }, React.createElement(motion.div, {
    className: contentClassNames,
    role: "dialog",
    initial: 'hidden',
    animate: props.isOpen ? 'visible' : 'hidden',
    variants: getAnimationVariants()
  }, showClose ? React.createElement(Close, {
    appearance: "minimal",
    intent: intent,
    onClick: overlayProps.onClose
  }) : null, React.createElement(Box, {
    isScrollable: true,
    isFullHeight: true,
    elevate: 3,
    intent: intent
  }, children))));
};
Dialog.displayName = 'Dialog';
Dialog.defaultProps = {
  allowOverflow: false,
  position: DialogPositionType.CENTER,
  size: DialogSizeType.AUTO,
  isClosedOnEscape: true,
  isClosedOnOutsideClick: true,
  hasBackdrop: true,
  showClose: true,
  transitionDuration: 250,
  isBlocking: true,
  preventBodyScroll: true
};
Dialog.Header = DialogHeader;
Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;
Dialog.Wrap = AttachedDialog;
function getBasePosition(position) {
  if (position.startsWith(DialogPositionType.TOP)) {
    return DialogPositionType.TOP;
  }
  if (position.startsWith(DialogPositionType.LEFT)) {
    return DialogPositionType.LEFT;
  }
  if (position.startsWith(DialogPositionType.RIGHT)) {
    return DialogPositionType.RIGHT;
  }
  if (position.startsWith(DialogPositionType.BOTTOM)) {
    return DialogPositionType.BOTTOM;
  }
  return DialogPositionType.CENTER;
}